import {Grid, MenuItem, TextField, Typography} from "@mui/material"
import {useEffect, useState} from "react"
import {ModalAcceptButton, ModalCancelButton,} from "../../../constants/component.constants"
import {ModalContainer, ModalInnerContainer, ResponsiveRow,} from "../../../constants/layout.constants"
import {isEmptyString, isNullUndefined} from "../../../util/util"

import {setMessage} from "../../../actions/message"
import {getIdTypes} from "../../../services/list.service"
import {saveListingApplication} from "../../../services/listingsServices/listing.service"
import {fetchPerson} from "../../../services/workOrder.service"
import {useDispatch, useSelector} from "react-redux";

export default function ListingApplicationModal(props) {
    const [firstName, setFirstName] = useState("")
    const [middleName, setMiddleName] = useState("")
    const [lastName, setLastName] = useState("")
    const [email, setEmail] = useState("")
    const [phoneNo, setPhoneNo] = useState("")
    const [officeTelNo, setOfficeTelNo] = useState("")
    const [idNo, setIdNo] = useState("")
    const [idTypes, setIdTypes] = useState([])
    const [idType, setIdType] = useState("")
    const [note, setNote] = useState("")
    const [hasPrefilled, setHasPrefilled] = useState(false)
    const dispatch = useDispatch()
    const user = useSelector((state) => state.auth.user)

    // Check if we're in edit mode
    const isEditMode = props.applicationItem && props.applicationItem.id

    useEffect(() => {
        getIdTypes()
            .then((idTypes) => setIdTypes(idTypes))
            .catch((error) => {
                console.error("getIdTypes Error: ", error);
            })
    }, [])

    // Populate form fields when in edit mode
    useEffect(() => {
        if (isEditMode && props.applicationItem) {
            setFirstName(props.applicationItem.applicant?.firstName || "")
            setMiddleName(props.applicationItem.applicant?.middleName || "")
            setLastName(props.applicationItem.applicant?.lastName || "")
            setEmail(props.applicationItem.applicant?.email || "")
            setPhoneNo(props.applicationItem.applicant?.mobilePhone || "")
            setOfficeTelNo(props.applicationItem.applicant?.officePhone || "")
            setIdNo(props.applicationItem.applicant?.idNo || "")
            setIdType(props.applicationItem.applicant?.idType || "")
            setNote(props.applicationItem.notes || "")
        }
    }, [isEditMode, props.applicationItem])

    // Prefill form fields with current user data for new applications
    useEffect(() => {
        if (!isEditMode && user && props.openModal && !hasPrefilled) {
            // Fetch person details using the userId
            fetchPerson(user.userId)
                .then((personData) => {
                    setFirstName(personData.firstName || "")
                    setMiddleName(personData.middleName || "")
                    setLastName(personData.lastName || "")
                    setEmail(personData.email || "")
                    setPhoneNo(personData.mobilePhone || "")
                    setOfficeTelNo(personData.officePhone || "")
                    setIdNo(personData.idNumber || "")
                    setIdType(personData.idTypeCd || "")
                    setHasPrefilled(true)
                })
                .catch((error) => {
                    console.error("Error fetching person details:", error);
                    // If fetching fails, still mark as prefilled to avoid retries
                    setHasPrefilled(true)
                })
        }
    }, [isEditMode, user, props.openModal, hasPrefilled])

    const validateFormData = () => {
        // Only validate person details for new applications
        if (!isEditMode) {
            if (isEmptyString(firstName) || isNullUndefined(firstName)) {
                dispatch(
                    setMessage({
                        type: "warning",
                        message: "First Name is required.",
                    })
                )
                return false
            }

            if (isEmptyString(lastName) || isNullUndefined(lastName)) {
                dispatch(
                    setMessage({
                        type: "warning",
                        message: "Last Name is required.",
                    })
                )
                return false
            }

            // if (isEmptyString(email) || isNullUndefined(email)) {
            //     dispatch(
            //         setMessage({
            //             type: "warning",
            //             message: "Email is required.",
            //         })
            //     )
            //     return false
            // }

            if (isEmptyString(phoneNo) || isNullUndefined(phoneNo)) {
                dispatch(
                    setMessage({
                        type: "warning",
                        message: "Phone Number is required.",
                    })
                )
                return false
            }

            if (isEmptyString(idNo) || isNullUndefined(idNo)) {
                dispatch(
                    setMessage({
                        type: "warning",
                        message: "ID Number is required.",
                    })
                )
                return false
            }

            if (isEmptyString(idType) || isNullUndefined(idType)) {
                dispatch(
                    setMessage({
                        type: "warning",
                        message: "ID Type is required.",
                    })
                )
                return false
            }
        }

        // Always validate note field
        if (isEmptyString(note) || isNullUndefined(note)) {
            dispatch(
                setMessage({
                    type: "warning",
                    message: "A brief description for the application is required.",
                })
            )
            return false
        }

        return true
    }

    const handleSubmit = () => {
        let sendData = {
            id: isEditMode ? props.applicationItem.id : null,
            listingId: isEditMode ? props.applicationItem.listingId : props.listing.id,
            note: note
        }
        
        // Only include person details for new applications
        if (!isEditMode) {
            sendData = {
                ...sendData,
                firstName: firstName,
                middleName: middleName,
                lastName: lastName,
                email: email,
                phoneNumber: phoneNo,
                officeTelNo: officeTelNo,
                idNo: idNo,
                idType: idType
            }
        }

        validateFormData() && saveListingApplication(sendData)
            .then((response) => {
                if (!response) return
                dispatch(
                    setMessage({
                        type: response.type,
                        message: response.message,
                    })
                )
                if (response.type !== "error") {
                    closeModal()
                    if (props.onApplicationUpdated) {
                        props.onApplicationUpdated()
                    }
                }
            })
            .catch((error) => {
                console.error("saveListingApplication error ", error);
            })

    }

    const closeModal = () => {
        props.closeModal()
        // Reset fields when closing modal
        setFirstName('')
        setMiddleName('')
        setLastName('')
        setEmail('')
        setPhoneNo('')
        setOfficeTelNo('')
        setIdType('')
        setIdNo('')
        setNote('')
        setHasPrefilled(false)
    }

    return (
        <ModalContainer open={props.openModal} onClose={props.closeModal}>
            <ModalInnerContainer
                sx={{
                    maxHeight: {xs: "50hv", lg: "70vh"},
                    width: {xs: "80%", lg: "70%"},
                }}
            >
                <Typography variant="body1" sx={{color: "#037171", fontWeight: 600}}>
                    {isEditMode ? "Edit Application" : "Start Application"}
                </Typography>
                <Typography
                    variant="h2"
                    sx={{marginBottom: "10px", marginTop: "10px", fontWeight: 900}}
                >
                    {isEditMode ? props.applicationItem.listing?.propertyName : props.listing.propertyName}
                </Typography>
                {!isEditMode && user && (
                    <Typography variant="body2" sx={{color: "#666", marginBottom: "20px", fontStyle: "italic"}}>
                        Form prefilled with your account details. You can edit any field to apply on behalf of someone else.
                    </Typography>
                )}
                {isEditMode && (
                    <Typography variant="body2" sx={{color: "#666", marginBottom: "20px", fontStyle: "italic"}}>
                        Only the application note can be edited. Personal details are read-only.
                    </Typography>
                )}

                <ResponsiveRow
                    sx={{
                        width: "100%",
                        justifyContent: {xs: "center", lg: "space-between"},
                        marginTop: "20px",
                    }}
                >
                    <Grid
                        item
                        sx={{width: {xs: "100%", lg: "33.3%"}, marginBottom: "10px"}}
                    >
                        <TextField
                            variant="outlined"
                            sx={{
                                width: {xs: "100%", lg: "90%"},
                                backgroundColor: "#efefef",
                                borderRadius: "10px",
                            }}
                            label="First Name"
                            required={true}
                            value={firstName}
                            disabled={isEditMode}
                            onChange={(event) => {
                                let value = event.target.value
                                setFirstName(value)
                            }}
                        />
                    </Grid>{" "}
                    <Grid
                        item
                        sx={{width: {xs: "100%", lg: "33.3%"}, marginBottom: "10px"}}
                    >
                        <TextField
                            variant="outlined"
                            sx={{
                                width: {xs: "100%", lg: "90%"},
                                backgroundColor: "#efefef",
                                borderRadius: "10px",
                            }}
                            label="Middle Name (Optional)"
                            value={middleName}
                            disabled={isEditMode}
                            onChange={(event) => {
                                let value = event.target.value
                                setMiddleName(value)
                            }}
                        />
                    </Grid>{" "}
                    <Grid
                        item
                        sx={{width: {xs: "100%", lg: "33.3%"}, marginBottom: "10px"}}
                    >
                        <TextField
                            variant="outlined"
                            sx={{
                                width: {xs: "100%", lg: "90%"},
                                backgroundColor: "#efefef",
                                borderRadius: "10px",
                            }}
                            label="Last Name"
                            required={true}
                            value={lastName}
                            disabled={isEditMode}
                            onChange={(event) => {
                                let value = event.target.value
                                setLastName(value)
                            }}
                        />
                    </Grid>{" "}
                    <Grid
                        item
                        sx={{width: {xs: "100%", lg: "33.3%"}, marginBottom: "10px"}}
                    >
                        <TextField
                            variant="outlined"
                            sx={{
                                width: {xs: "100%", lg: "90%"},
                                backgroundColor: "#efefef",
                                borderRadius: "10px",
                            }}
                            label="Email (Optional)"
                            type="email"
                            value={email}
                            disabled={isEditMode}
                            onChange={(event) => {
                                let value = event.target.value
                                setEmail(value)
                            }}
                        />
                    </Grid>{" "}
                    <Grid
                        item
                        sx={{width: {xs: "100%", lg: "33.3%"}, marginBottom: "10px"}}
                    >
                        <TextField
                            variant="outlined"
                            sx={{
                                width: {xs: "100%", lg: "90%"},
                                backgroundColor: "#efefef",
                                borderRadius: "10px",
                            }}
                            label="Phone Number"
                            type="tel"
                            required={true}
                            value={phoneNo}
                            disabled={isEditMode}
                            onChange={(event) => {
                                let value = event.target.value
                                setPhoneNo(value)
                            }}
                        />
                    </Grid>{" "}
                    <Grid
                        item
                        sx={{width: {xs: "100%", lg: "33.3%"}, marginBottom: "10px"}}
                    >
                        <TextField
                            variant="outlined"
                            sx={{
                                width: {xs: "100%", lg: "90%"},
                                backgroundColor: "#efefef",
                                borderRadius: "10px",
                            }}
                            label="Office Tel (Optional)"
                            type="tel"
                            value={officeTelNo}
                            disabled={isEditMode}
                            onChange={(event) => {
                                let value = event.target.value
                                setOfficeTelNo(value)
                            }}
                        />
                    </Grid>{" "}
                    <Grid
                        item
                        sx={{width: {xs: "100%", lg: "33.3%"}, marginBottom: "10px"}}
                    >
                        <TextField
                            variant="outlined"
                            sx={{
                                width: {xs: "100%", lg: "90%"},
                                backgroundColor: "#efefef",
                                borderRadius: "10px",
                            }}
                            select
                            label="ID Type"
                            required={true}
                            value={idType}
                            disabled={isEditMode}
                            onChange={(event) => {
                                let value = event.target.value
                                setIdType(value)
                            }}
                        >
                            {idTypes && idTypes.length > 0 && idTypes.map(function (idType, i) {
                                return (
                                    <MenuItem key={i} value={idType.value}>
                                        {idType.label}
                                    </MenuItem>
                                )
                            }, this)}
                        </TextField>
                    </Grid>{" "}
                    <Grid
                        item
                        sx={{width: {xs: "100%", lg: "33.3%"}, marginBottom: "10px"}}
                    >
                        <TextField
                            variant="outlined"
                            sx={{
                                width: {xs: "100%", lg: "90%"},
                                backgroundColor: "#efefef",
                                borderRadius: "10px",
                            }}
                            label="ID Number"
                            required={true}
                            value={idNo}
                            disabled={isEditMode}
                            onChange={(event) => {
                                let value = event.target.value
                                setIdNo(value)
                            }}
                        />
                    </Grid>{" "}
                    <Grid
                        item
                        sx={{width: {xs: "100%", lg: "33.3%"}, marginBottom: "10px"}}
                    >
                        <TextField
                            variant="outlined"
                            sx={{
                                width: {xs: "100%", lg: "90%"},
                                backgroundColor: "#efefef",
                                borderRadius: "10px",
                            }}
                            label="Listing"
                            disabled
                            value={isEditMode ? props.applicationItem.listing?.propertyName : props.listing.propertyName}
                        />
                    </Grid>{" "}
                    <Grid
                        item
                        sx={{width: {xs: "100%", lg: "66.6%"}, marginBottom: "10px"}}
                    >
                        <TextField
                            variant="outlined"
                            sx={{
                                width: "100%",
                                backgroundColor: "#efefef",
                                borderRadius: "10px",
                            }}
                            label="Notes"
                            multiline
                            rows="5"
                            required={true}
                            value={note}
                            onChange={(event) => {
                                let value = event.target.value
                                setNote(value)
                            }}
                        />
                    </Grid>
                </ResponsiveRow>
                <ResponsiveRow
                    sx={{
                        width: "100%",
                        justifyContent: {xs: "center", lg: "flex-end"},
                    }}
                >
                    <ModalAcceptButton onClick={handleSubmit} sx={{width: {xs: "100%", lg: "200px"}}}>
                        {isEditMode ? "Update" : "Submit"}
                    </ModalAcceptButton>
                    <ModalCancelButton
                        onClick={closeModal}
                        sx={{width: {xs: "100%", lg: "200px"}}}
                    >
                        Cancel
                    </ModalCancelButton>
                </ResponsiveRow>
            </ModalInnerContainer>
        </ModalContainer>
    )
}
